import * as React from "react";
import clsx from "clsx";
import { createTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { GridCellParams } from "@mui/x-data-grid";
import { toNumber } from "lodash";

const defaultTheme = createTheme();
const useStyles = makeStyles(
  (theme) =>
    createStyles({
      root: {
        border: `1px solid ${theme.palette.divider}`,
        position: "relative",
        overflow: "hidden",
        width: "100%",
        height: 30,
        borderRadius: 3,
      },
      value: {
        position: "absolute",
        lineHeight: "30px",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      },
      bar: {
        height: "100%",
        "&.working": {
          backgroundColor: "#FEC108",
        },
        "&.done": {
          backgroundColor: "#12941F",
        },
        "&.overload": {
          backgroundColor: "#e74c3c",
        },
      },
    }),
  { defaultTheme }
);

interface ProgressBarProps {
  value: number;
}

const ProgressBar = React.memo(function ProgressBar(props: ProgressBarProps) {
  const { value } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div
        className={classes.value}
        style={{ color: value >= 100 ? "white" : "black" }}
      >{`${value.toLocaleString()} %`}</div>
      <div
        className={clsx(classes.bar, {
          working: value < 100,
          done: value === 100,
          overload: value > 100,
        })}
        style={{ maxWidth: `${value}%` }}
      />
    </div>
  );
});

export function renderProgress(params?: GridCellParams | number) {
  if (typeof params === "number") {

    return <ProgressBar value={params || 0} />;
  }
  return <ProgressBar value={toNumber(params?.value)} />;
}
